"use client";

import { MarketingHeroEmailCta } from "@/components/redesign/MarketingHeroEmailCta";
import clsx from "clsx";

export type MarketingHeroHeaderProps = {
  title: string;
  subtitle?: string;
  showEmailCta?: boolean;
  emailPlaceholder?: string;
  ctaLabel?: string;
  personalEmailWarning?: string;
  continueAnywayLabel?: string;
  onEmailSubmit?: (email: string) => void;
  /** Identifies where the form was submitted from for analytics. */
  source?: string;
  className?: string;
};

export function MarketingHeroHeader({
  title,
  subtitle,
  showEmailCta = false,
  emailPlaceholder = "",
  ctaLabel = "",
  personalEmailWarning = "",
  continueAnywayLabel = "",
  onEmailSubmit,
  source,
  className,
}: Readonly<MarketingHeroHeaderProps>) {
  const canShowEmailCta =
    showEmailCta &&
    emailPlaceholder &&
    ctaLabel &&
    personalEmailWarning &&
    continueAnywayLabel;

  const titleTextClass = clsx(
    "font-monument text-[2.25rem] leading-[1.15] tracking-tight",
  );

  const subtitleTextClass = clsx(
    "font-monument text-[1.75rem] leading-[1.15] tracking-tight",
  );

  return (
    <section
      className={clsx("flex justify-center px-4 pt-16 pb-12", className)}
    >
      <div className="w-full max-w-6xl text-left">
        <div className="max-w-4xl">
          <h1 className={clsx(titleTextClass)}>
            {title}
          </h1>

          {subtitle ? (
            <p
              className={clsx(
                subtitleTextClass,
                "mt-1 max-w-2xl text-black/70",
              )}
            >
              {subtitle}
            </p>
          ) : null}

          {canShowEmailCta ? (
            <div className="mt-8 md:mt-10">
              <MarketingHeroEmailCta
                emailPlaceholder={emailPlaceholder}
                ctaLabel={ctaLabel}
                personalEmailWarning={personalEmailWarning}
                continueAnywayLabel={continueAnywayLabel}
                onSubmit={onEmailSubmit}
                source={source}
              />
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
